import {  Modal, Button } from 'react-bootstrap';

const Iframe = ( props ) => {
    return (<div dangerouslySetInnerHTML={ {__html:  props.iframe ? props.iframe:""}} />);
  }

const CCModal = ( { show, handleClose, iframeUrl, handleDownload }) => {
    const iframe = `<iframe scrolling="yes" title="secure payment"'
                        src='${iframeUrl}' frameborder="no" allowtransparency="true" allowfullscreen="true">
                        </iframe>`;


    return (
   
        <Modal  animation={false} transition="false" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <Button variant="primary" onClick={handleDownload}>
                        <i className="fa fa-file-pdf-o fa-lg pr-2"></i>
                        Download Invoice
                    </Button>                    
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className="iframe-container">
                <div className="row">
                    <div className="col-md-6 offset-md-3 col-sm-1 offset-sm-1 text-center">
                        <h2 className="lead">Thank you for your order.</h2>
                        <p>Credit Card payments are processed through the University of Oregon's secure payment portal. Failure to complete payment may delay fulfillment of your order</p>
                        <p>   Please wait while the payment portal is loaded.</p>
                        
                    </div>
                    <div className="col-md-3 col-sm-1"></div>
                </div>

                
                <Iframe iframe={iframe} />
            </div>     
            </Modal.Body>
            {/* <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Back to Invoice
                </Button>
                <Button variant="primary" onClick={handleDownload}>
                    <i className="fa fa-file-pdf-o fa-lg p-2"></i>
                    Download Invoice
                </Button>
            </Modal.Footer> */}
        </Modal>
    );
}

export { CCModal };